export default "__VITE_ASSET__BthcBCMf__"